<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'DonneesPersonnelles'
});
</script>
<template>
  <ka-container code="page-rgpd-review">
    <ka-text code="donnees-personnelles">
      <h1 v-html="t('pageRgpdReview.donneesPersonnelles.value', `Données personnelles`)" />
    </ka-text>
    <!-- Pourquoi Matchers ? -->
    <ka-container code="pourquoi-matchers">
      <!-- conteneur switch et image -->
      <ka-container code="conteneur-switch-et-image">
        <!-- Container -->
        <ka-container code="container">
          <ka-text code="titre">
            <span v-html="t('pageRgpdReview.pourquoiMatchers.conteneurSwitchEtImage.container.titre.value', `Pourquoi Matchers ?`)" />
          </ka-text>
          <!-- Container -->
          <ka-container code="container-1">
            <ka-text
              code="text-1"
              :options="{
                click: page.text1Click,
                $state: { selected: page.$data.switchPourquoiMatchers === 0 }
              }">
              <span v-html="t('pageRgpdReview.pourquoiMatchers.conteneurSwitchEtImage.container.container1.text1.value', `La protection des données personnelles`)" />
            </ka-text>
            <ka-text
              code="text-2"
              :options="{
                click: page.text2Click,
                $state: { selected: page.$data.switchPourquoiMatchers === 1 }
              }">
              <span v-html="t('pageRgpdReview.pourquoiMatchers.conteneurSwitchEtImage.container.container1.text2.value', `Finalités et durées de conservation`)" />
            </ka-text>
            <ka-text
              code="text-3"
              :options="{
                click: page.text3Click,
                $state: { selected: page.$data.switchPourquoiMatchers === 2 }
              }">
              <span v-html="t('pageRgpdReview.pourquoiMatchers.conteneurSwitchEtImage.container.container1.text3.value', `Destinataires possible`)" />
            </ka-text>
            <ka-text
              code="text-4"
              :options="{
                click: page.text4Click,
                $state: { selected: page.$data.switchPourquoiMatchers === 3 }
              }">
              <span v-html="t('pageRgpdReview.pourquoiMatchers.conteneurSwitchEtImage.container.container1.text4.value', `Vos droits`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <!-- Container 1 -->
        <ka-container code="container-2">
          <ka-image
            code="image"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              imgFit: `cover`,
              alt: `Formations adaptées et gratuites pour toutes les TPE et PME : c'est ça, Matchers `
            }"
            :value="$first([
              page.$data.switchPourquoiMatchers === 0 ? `https://ucarecdn.com/54fff621-8aeb-4f7a-b99d-7f704d9d8834/` : undefined,
              page.$data.switchPourquoiMatchers === 1 ? `https://ucarecdn.com/b578d74d-6fba-4b0e-a11d-6fb60ad36037/` : undefined,
              page.$data.switchPourquoiMatchers === 2 ? `https://ucarecdn.com/7a074fa1-0197-4fd3-80e9-b3b1e9782875/` : undefined,
              `https://ucarecdn.com/2a19950b-62c5-432a-9465-ced8167a0fe0/`
            ])" />
        </ka-container>
      </ka-container>
      <!-- conteneur texte -->
      <ka-container code="conteneur-texte">
        <ka-text code="text-5">
          <span
            v-html="t('pageRgpdReview.pourquoiMatchers.conteneurTexte.text5.value', `{0} `, [$first([
              page.$data.switchPourquoiMatchers === 0 ? `La protection des données personnelles` : undefined,
              page.$data.switchPourquoiMatchers === 1 ? `Finalités et durées de conservation` : undefined,
              page.$data.switchPourquoiMatchers === 2 ? `Destinataires possible` : undefined,
              `Vos droits`
            ])
            ])" />
        </ka-text>
        <ka-text code="contenu">
          <span
            v-html="t('pageRgpdReview.pourquoiMatchers.conteneurTexte.contenu.value', `{0} `, [$first([
              page.$data.switchPourquoiMatchers === 0 ? `<span style=&#8220;background-color:rgb(255,255,255);color:rgb(34,34,34);font-size:17px;&#8220;>La protection des données personnelles est un enjeu important pour Matchers, c’est pour cela que nous nous engageons à mettre tout en œuvre pour respecter la confidentialité de vos données. Par conséquent, les informations collectées ne sont pas revendues à des tiers.</span>` : undefined,
              page.$data.switchPourquoiMatchers === 1 ? `<p style=&#8220;margin-left:0px;&#8220;><span style=&#8220;font-size:17px;&#8220;>Matchers, Z.A.E. Espace Lunel Littoral - 177b avenue Louis Lumière, 34400 Lunel, en tant que responsable de traitement collecte vos données à caractère personnel dans le cadre des finalités suivantes :</span></p><p style=&#8220;margin-left:0px;&#8220;> </p><figure class=&#8220;image&#8220;><img src=&#8220;https://ucarecdn.com/ee421644-b07d-4dda-b2ec-d1956a2f2f40/-/quality/smart/-/format/auto/-/stretch/off/-/resize/896x/&#8220; alt=&#8220;Switch-Image&#8220;></figure>` : undefined,
              page.$data.switchPourquoiMatchers === 2 ? `<p style=&#8220;margin-left:0px;&#8220;><span style=&#8220;background-color:rgb(255,255,255);color:rgb(34,34,34);font-size:17px;&#8220;>Dans le cadre des traitements de données personnelles réalisés, Matchers est susceptible de communiquer vos données personnelles aux destinataires suivants : service interne de Matchers légitime à traiter vos données personnelles, organismes sociaux habilités ayant besoin d’y avoir accès.</span></p>` : undefined,
              `<p style=&#8220;margin-left:0px;&#8220;><span style=&#8220;font-size:17px;&#8220;>En tant que personne dont les données sont collectées, vous disposez de droits vous permettant de : </span></p><p style=&#8220;margin-left:0px;&#8220;> </p><ul><li><span style=&#8220;font-size:17px;&#8220;>accéder à vos données, </span></li><li><span style=&#8220;font-size:17px;&#8220;>demander leur rectification en cas d’erreur, </span></li><li><span style=&#8220;font-size:17px;&#8220;>demander leur effacement, </span></li><li><span style=&#8220;font-size:17px;&#8220;>demander la limitation de leur traitement, </span></li><li><span style=&#8220;font-size:17px;&#8220;>demander leur portabilité, </span></li><li><span style=&#8220;font-size:17px;&#8220;>vous opposer à leur traitement, </span></li><li><span style=&#8220;font-size:17px;&#8220;>définir des directives relatives à leur sort après votre décès. </span></li></ul><p style=&#8220;margin-left:0px;&#8220;> </p><p style=&#8220;margin-left:0px;&#8220;><span style=&#8220;font-size:17px;&#8220;>Vous disposez également du droit d'introduire une réclamation auprès de la CNIL. (3 place de Fontenoy - TSA 80715 – 75334 Paris cedex 07). </span></p><p style=&#8220;margin-left:0px;&#8220;> </p><p style=&#8220;margin-left:0px;&#8220;><span style=&#8220;font-size:17px;&#8220;>Enfin, lorsque vous avez donné votre consentement à un traitement de données, vous pouvez le retirer à tout moment, sans remettre en cause les opérations effectuées préalablement à ce retrait. </span></p><p style=&#8220;margin-left:0px;&#8220;> </p><p style=&#8220;margin-left:0px;&#8220;><span style=&#8220;font-size:17px;&#8220;>Pour mieux connaître vos droits, rendez-vous sur</span> <span style=&#8220;color:rgb(230,153,77);&#8220;> </span><span style=&#8220;color:rgb(230,153,77);font-size:17px;&#8220;>le site de la CNIL</span><span style=&#8220;font-size:17px;&#8220;>.</span></p><p style=&#8220;margin-left:0px;&#8220;> </p><p style=&#8220;margin-left:0px;&#8220;><span style=&#8220;font-size:17px;&#8220;>Vous pouvez exercer vos droits en remplissant<strong> </strong></span><a href=&#8220;https://docs.google.com/forms/d/13uhgBXWkd02LSzWmFhiKzgDW9tZuUGesJpYhas795tk/edit?pli=1&#8220;><span style=&#8220;color:rgb(0,0,0);font-size:17px;&#8220;><strong>ce formulaire</strong></span></a><span style=&#8220;font-size:17px;&#8220;> ou en contactant Matchers à l’adresse électronique suivante : </span>rgpd&#64;matchers.fr <span style=&#8220;font-size:17px;&#8220;>ou par courrier postal à l’adresse suivante Matchers, 120 rue Adrien Proby, 34090 Montpellier. </span></p><p style=&#8220;margin-left:0px;&#8220;> </p><p style=&#8220;margin-left:0px;&#8220;><span style=&#8220;font-size:17px;&#8220;>Vous devez, lorsque vous exercez vos droits, justifier de votre identité par tous moyens. Cependant, si des doutes raisonnables persistent quant à l'exactitude de votre identité, Matchers pourra vous demander des informations supplémentaires apparaissant nécessaires y compris, lorsque la situation l'exige, la photocopie signée d'un titre d'identité. </span></p><p style=&#8220;margin-left:0px;&#8220;> </p><p style=&#8220;margin-left:0px;&#8220;><span style=&#8220;font-size:17px;&#8220;>Le présent document a été validé préalablement à sa diffusion par le Délégué à la protection des données de Matchers. </span></p><p style=&#8220;margin-left:0px;&#8220;> </p><p style=&#8220;margin-left:0px;&#8220;><span style=&#8220;font-size:17px;&#8220;>Dernière mise à jour : Février 2023</span></p>`
            ])
            ])" />
        </ka-text>
        <ka-image
          code="switch-image"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            hidden: page.$data.switchPourquoiMatchers === 1 ? false : null,
            alt: `Switch-Image`
          }"
          value="https://ucarecdn.com/ee421644-b07d-4dda-b2ec-d1956a2f2f40/" />
      </ka-container>
    </ka-container>
    <!-- Conteneur -->
    <ka-container
      code="conteneur"
      inner>
      <!-- Textes -->
      <ka-container code="textes">
        <ka-text code="vous-avez-des-questions">
          <span v-html="t('pageRgpdReview.conteneur.textes.vousAvezDesQuestions.value', `Vous avez des questions ?`)" />
        </ka-text>
        <ka-text code="vous-voulez-parler">
          <span v-html="t('pageRgpdReview.conteneur.textes.vousVoulezParler.value', `Vous voulez parler plan de formation ? Vous avez des questions sur notre fonctionnement ? Vous avez du mal à définir précisément votre besoin ?`)" />
        </ka-text>
      </ka-container>
      <!-- Boutons -->
      <ka-container code="boutons">
        <ka-button
          code="prendre-rendez-vous"
          :options="{
            ripple: true,
            href: `https://www.matchers.fr/faq`,
            ariaLabel: `prendre rendez vous`,
            click: page.prendreRendezVousClick,
            hidden: null
          }">
          <span v-html="t('pageRgpdReview.conteneur.boutons.prendreRendezVous.value', `Voir la F.A.Q`)" />
        </ka-button>
        <ka-button
          code="button-1"
          :options="{
            ripple: true,
            href: { name: `Contact` },
            click: page.button1Click
          }">
          <span v-html="t('pageRgpdReview.conteneur.boutons.button1.value', `Contactez-nous`)" />
        </ka-button>
      </ka-container>
    </ka-container>
    <!-- Conteneur 1 -->
    <ka-container
      code="conteneur-1"
      :options="{ hidden: null }">
      <!-- Conteneur 2 -->
      <ka-container code="conteneur-2">
        <ka-text code="titre-de-larticle">
          <span v-html="t('pageRgpdReview.conteneur1.conteneur2.titreDeLarticle.value', `Titre de l’article<br>Titre de l’article`)" />
        </ka-text>
        <ka-text code="lorem-ipsum-dolor-sit">
          <span v-html="t('pageRgpdReview.conteneur1.conteneur2.loremIpsumDolorSit.value', `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`)" />
        </ka-text>
        <ka-text code="top-3-de-nos-articles">
          <span v-html="t('pageRgpdReview.conteneur1.conteneur2.top3DeNosArticles.value', `TOP 3 DE NOS ARTICLES<br> `)" />
        </ka-text>
        <ka-text-link
          code="lien"
          value="Lire l’article >" />
      </ka-container>
      <!-- Conteneur 1 -->
      <ka-container code="container-3">
        <ka-image
          code="image-1"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Image`
          }"
          value="https://ucarecdn.com/c680c61d-1e1f-4489-8f50-8981a977b28b/" />
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { donneesPersonnelles } from './store'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p43')
const appData = appDataStore()
const page = donneesPersonnelles()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
